import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-notification-destination',
  templateUrl: './help-add-notification-destination.component.html',
  styleUrls: ['./help-add-notification-destination.component.scss']
})
export class HelpAddNotificationDestinationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
